import type { Glyph } from './registries';

/** 14px status glyphs. Shape differs per state so status never depends on colour alone. */
export function StatusGlyph({ glyph, className }: { glyph: Glyph; className?: string }) {
  const common = { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true, className };
  switch (glyph) {
    case 'dashed':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" strokeDasharray="3.2 3.2" /></svg>;
    case 'empty':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /></svg>;
    case 'quarter':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M12 3.5A8.5 8.5 0 0 1 20.5 12H12z" fill="currentColor" stroke="none" /></svg>;
    case 'half':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none" /></svg>;
    case 'three-quarter':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M12 3.5a8.5 8.5 0 1 1-8.5 8.5H12z" fill="currentColor" stroke="none" /></svg>;
    case 'bank':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M9 15l6-6M10 9h5v5" /></svg>;
    case 'attention':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5v5M12 16.2h.01" /></svg>;
    case 'return':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M10.5 13.5 8 11l2.5-2.5" /><path d="M8 11h5.5a2.5 2.5 0 0 1 0 5H12" /></svg>;
    case 'query':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M9.8 9.5a2.3 2.3 0 0 1 4.4.8c0 1.5-2.2 2-2.2 2M12 15.8h.01" /></svg>;
    case 'check':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="m8.5 12.2 2.4 2.4 4.6-5" /></svg>;
    case 'cross':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="m9.5 9.5 5 5M14.5 9.5l-5 5" /></svg>;
    case 'check-filled':
      return <svg {...common}><circle cx="12" cy="12" r="9" fill="currentColor" stroke="none" /><path d="m8.5 12.2 2.4 2.4 4.6-5" stroke="var(--color-positive)" /></svg>;
    case 'slash':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M6.5 17.5l11-11" /></svg>;
    case 'clock':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></svg>;
    case 'pause':
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M10 9v6M14 9v6" /></svg>;
    case 'lock':
      return <svg {...common}><rect x="6" y="11" width="12" height="9" rx="1.5" /><path d="M9 11V8.5a3 3 0 0 1 6 0V11" /></svg>;
  }
}
